/* ==========================================================================
   Atelier Sur — global.js
   Load mark, scroll reveal, AJAX bag drawer with Saved tab, product form,
   quick-add toggle on product cards.
   No framework. Uses Shopify's /cart AJAX API.
   ========================================================================== */
(function () {
  'use strict';

  var money = (window.AtelierSur && window.AtelierSur.moneyFormat) || '${{amount}}';
  var SAVED_KEY = 'as_saved_v1';
  var PROMPT_DISMISSED_KEY = 'as_saved_prompt_off';

  // Second-save sign-up prompt. Edit the wording here.
  var PROMPT = {
    minSaved: 2,
    text: 'Create an account for faster checkout and your order history in one place.',
    cta: 'Sign in or create an account'
  };

  // Shown on a bag line when the piece sold to someone else while it sat there.
  var STALE = {
    line: 'No longer available',
    notice: 'A piece in your bag has sold. Remove it to continue to checkout.'
  };

  var C = {
    bone: '#F3EFE6',
    ink: '#1C1B19',
    cognac: '#7A5C3E',
    rose: '#B8916B',
    sage: '#5F6A56',
    mono: "'IBM Plex Mono', monospace",
    serif: "'Cormorant', serif",
    body: "'Hanken Grotesk', sans-serif"
  };

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return money.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* ---- Saved for later (localStorage) ------------------------------------ */
  function readSaved() {
    try { return JSON.parse(localStorage.getItem(SAVED_KEY)) || []; }
    catch (e) { return []; }
  }
  function writeSaved(list) {
    try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function addSaved(entry) {
    var list = readSaved();
    if (list.some(function (i) { return String(i.id) === String(entry.id); })) return;
    list.unshift(entry);
    writeSaved(list);
  }
  function removeSaved(id) {
    writeSaved(readSaved().filter(function (i) { return String(i.id) !== String(id); }));
  }
  // A piece lives in one place only: anything in the bag leaves Saved.
  function pruneSaved() {
    var list = readSaved();
    var pruned = list.filter(function (i) { return inBag.indexOf(String(i.id)) === -1; });
    if (pruned.length !== list.length) writeSaved(pruned);
    return pruned;
  }

  function promptDismissed() {
    try { return localStorage.getItem(PROMPT_DISMISSED_KEY) === '1'; }
    catch (e) { return false; }
  }
  function dismissPrompt() {
    try { localStorage.setItem(PROMPT_DISMISSED_KEY, '1'); } catch (e) {}
  }

  /* ---- Load mark (Lucero) ------------------------------------------------ */
  function initOverlay() {
    var overlay = document.getElementById('as-overlay');
    if (!overlay) return;
    if (sessionStorage.getItem('as_seen')) { overlay.classList.add('gone'); return; }
    sessionStorage.setItem('as_seen', '1');
    setTimeout(function () { overlay.style.opacity = '0'; overlay.style.pointerEvents = 'none'; }, 1150);
    setTimeout(function () { overlay.classList.add('gone'); }, 1850);
  }

  /* ---- Scroll reveal ----------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.as-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Bag drawer -------------------------------------------------------- */
  var drawer, overlayEl, activeTab = 'bag', lastCart = null;
  var inBag = [];
  var soldOut = [];        // variant ids in the bag that are no longer purchasable
  var lastCheck = 0;

  function openDrawer() {
    if (!drawer) return;
    if (overlayEl) {
      overlayEl.hidden = false;
      requestAnimationFrame(function () { overlayEl.classList.add('is-open'); });
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    if (overlayEl) overlayEl.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { if (overlayEl) overlayEl.hidden = true; }, 450);
  }

  function updateCounters(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---- Stale stock check ------------------------------------------------- */
  function validateStock(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) { soldOut = []; return Promise.resolve(cart); }

    var handles = [];
    items.forEach(function (i) {
      if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });

    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var available = {};
      products.forEach(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) { available[String(v.id)] = v.available; });
      });
      soldOut = items
        .map(function (i) { return String(i.variant_id); })
        .filter(function (id) { return available[id] === false; });
      lastCheck = Date.now();
      return cart;
    });
  }

  function tabsHtml(bagCount, savedCount) {
    function tab(key, label, count) {
      var on = activeTab === key;
      return '<button type="button" data-bag-tab="' + key + '" style="' +
        'background:none;border:0;padding:0 0 8px;cursor:pointer;' +
        'font-family:' + C.mono + ';font-size:11px;letter-spacing:.18em;text-transform:uppercase;' +
        'color:' + (on ? C.cognac : 'rgba(122,92,62,.45)') + ';' +
        'border-bottom:1px solid ' + (on ? C.rose : 'transparent') + ';">' +
        esc(label) + ' (' + count + ')</button>';
    }
    return '<div style="display:flex;gap:26px;justify-content:center;margin:0 0 34px;">' +
      tab('bag', 'Bag', bagCount) + tab('saved', 'Saved', savedCount) + '</div>';
  }

  function promptHtml() {
    return '<div style="background:rgba(122,92,62,.07);padding:24px 22px;margin:0 0 30px;text-align:center;position:relative;">' +
      '<button type="button" data-prompt-dismiss aria-label="Dismiss" style="' +
        'position:absolute;top:10px;right:12px;background:none;border:0;padding:4px;cursor:pointer;' +
        'font-family:' + C.mono + ';font-size:13px;line-height:1;color:rgba(122,92,62,.45);">×</button>' +
      '<p style="font-family:' + C.body + ';font-weight:300;font-size:13px;line-height:1.65;' +
        'color:rgba(122,92,62,.9);margin:0 0 14px;">' + esc(PROMPT.text) + '</p>' +
      '<a href="/account/login" style="font-family:' + C.mono + ';font-size:10px;letter-spacing:.16em;' +
        'text-transform:uppercase;color:' + C.rose + ';text-decoration:none;' +
        'border-bottom:1px solid rgba(184,145,107,.5);padding-bottom:4px;">' + esc(PROMPT.cta) + '</a>' +
    '</div>';
  }

  function staleNoticeHtml() {
    return '<div style="border:1px solid rgba(95,106,86,.5);padding:18px 20px;margin:0 0 26px;">' +
      '<p style="font-family:' + C.mono + ';font-size:10.5px;letter-spacing:.1em;line-height:1.8;' +
        'text-transform:uppercase;color:' + C.sage + ';margin:0;">' + esc(STALE.notice) + '</p>' +
    '</div>';
  }

  function lineHtml(opts) {
    var img = opts.image
      ? '<img src="' + esc(sizedImage(opts.image, 240)) + '" alt="' + esc(opts.title) + '" style="width:100%;height:auto;display:block;' + (opts.stale ? 'opacity:.45;' : '') + '">'
      : '';
    var actions = opts.actions.map(function (a) {
      return '<button type="button" ' + a.attr + ' style="' +
        'background:none;border:0;padding:0;cursor:pointer;' +
        'font-family:' + C.mono + ';font-size:10px;letter-spacing:.14em;text-transform:uppercase;' +
        'color:rgba(122,92,62,.55);border-bottom:1px solid rgba(122,92,62,.25);">' +
        esc(a.label) + '</button>';
    }).join('');

    var flag = opts.stale
      ? '<div style="font-family:' + C.mono + ';font-size:10px;letter-spacing:.16em;text-transform:uppercase;' +
        'color:' + C.sage + ';margin-top:12px;">' + esc(STALE.line) + '</div>'
      : '';

    var price = opts.stale
      ? ''
      : '<div style="font-family:' + C.mono + ';font-size:13px;color:' + C.rose + ';margin-top:12px;">' + esc(opts.price) + '</div>';

    return '<li style="display:grid;grid-template-columns:88px 1fr;gap:20px;padding:26px 0;' +
      'border-bottom:1px solid rgba(122,92,62,.16);list-style:none;">' +
      '<a href="' + esc(opts.url || '#') + '" style="display:block;">' + img + '</a>' +
      '<div>' +
        '<div style="font-family:' + C.mono + ';font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:' + C.cognac + ';margin-bottom:8px;">' + esc(opts.brand) + '</div>' +
        '<div style="font-family:' + C.body + ';font-weight:300;font-size:13.5px;line-height:1.5;color:rgba(122,92,62,.85);">' + esc(opts.title) + '</div>' +
        (opts.variant ? '<div style="font-family:' + C.body + ';font-weight:300;font-size:13.5px;line-height:1.5;color:rgba(122,92,62,.85);">' + esc(opts.variant) + '</div>' : '') +
        price + flag +
        '<div style="display:flex;gap:18px;margin-top:12px;flex-wrap:wrap;">' + actions + '</div>' +
      '</div>' +
    '</li>';
  }

  function emptyHtml(text) {
    return '<p style="font-family:' + C.body + ';font-weight:300;font-size:14px;text-align:center;margin:0 0 32px;color:' + C.cognac + ';">' + esc(text) + '</p>';
  }

  function buttonHtml(label, kind, attr, disabled) {
    var base = 'display:block;width:100%;text-align:center;padding:17px 20px;' +
      'font-family:' + C.mono + ';font-size:11px;letter-spacing:.2em;text-transform:uppercase;' +
      'text-decoration:none;border-radius:0;' + (disabled ? 'cursor:not-allowed;opacity:.4;' : 'cursor:pointer;');
    var skin = kind === 'solid'
      ? 'background:' + C.ink + ';color:' + C.bone + ';border:1px solid ' + C.ink + ';'
      : 'background:transparent;color:' + C.cognac + ';border:1px solid rgba(122,92,62,.4);margin-top:14px;';
    return '<button type="button" ' + (attr || '') + (disabled ? ' disabled' : '') +
      ' style="' + base + skin + '">' + esc(label) + '</button>';
  }

  function render() {
    if (!drawer) return;
    var scroll = drawer.querySelector('.as-bag-scroll');
    if (!scroll) return;

    var cart = lastCart || { items: [], item_count: 0, total_price: 0 };
    var saved = pruneSaved();
    var heading = activeTab === 'saved' ? 'Saved' : 'Shopping Bag';
    var hasStale = soldOut.length > 0;

    var html = '<h2 class="as-bag-title">' + heading + '</h2>' + tabsHtml(cart.item_count, saved.length);

    if (activeTab === 'bag') {
      if (!cart.items.length) {
        html += emptyHtml('Your bag is empty.');
        html += buttonHtml('Continue Shopping', 'ghost', 'data-bag-continue');
      } else {
        if (hasStale) html += staleNoticeHtml();

        html += '<ul style="margin:0;padding:0;">';
        cart.items.forEach(function (item) {
          var stale = soldOut.indexOf(String(item.variant_id)) !== -1;
          var actions = stale
            ? [{ label: 'Remove', attr: 'data-remove data-key="' + esc(item.key) + '" data-id="' + esc(item.variant_id) + '"' }]
            : [
                { label: 'Save for later', attr: 'data-save-later data-key="' + esc(item.key) + '" data-id="' + esc(item.variant_id) + '"' },
                { label: 'Remove', attr: 'data-remove data-key="' + esc(item.key) + '" data-id="' + esc(item.variant_id) + '"' }
              ];

          html += lineHtml({
            image: item.image,
            url: item.url,
            brand: item.vendor || item.product_title,
            title: item.product_title,
            variant: (item.variant_title && item.variant_title.indexOf('Default') === -1) ? item.variant_title : '',
            price: formatMoney(item.final_line_price),
            stale: stale,
            actions: actions
          });
        });
        html += '</ul>';

        html += '<div style="display:flex;justify-content:space-between;align-items:center;' +
          'background:rgba(122,92,62,.07);padding:26px 24px;margin:34px 0;">' +
          '<span style="font-family:' + C.serif + ';font-size:18px;letter-spacing:.22em;text-transform:uppercase;padding-left:.22em;color:' + C.cognac + ';">Subtotal</span>' +
          '<span style="font-family:' + C.mono + ';font-size:15px;color:' + C.rose + ';">' + formatMoney(cart.total_price) + '</span>' +
        '</div>';

        html += buttonHtml('Review Bag & Checkout', 'solid', 'data-bag-checkout', hasStale);
        html += buttonHtml('Continue Shopping', 'ghost', 'data-bag-continue');
      }
    } else {
      if (!saved.length) {
        html += emptyHtml('Nothing saved yet.');
        html += buttonHtml('Continue Shopping', 'ghost', 'data-bag-continue');
      } else {
        if (saved.length >= PROMPT.minSaved && !promptDismissed()) html += promptHtml();

        html += '<ul style="margin:0;padding:0;">';
        saved.forEach(function (item) {
          html += lineHtml({
            image: item.image,
            url: item.url,
            brand: item.brand,
            title: item.title,
            variant: item.variant,
            price: item.price,
            actions: [
              { label: 'Move to bag', attr: 'data-move-to-bag data-id="' + esc(item.id) + '"' },
              { label: 'Remove', attr: 'data-drop-saved data-id="' + esc(item.id) + '"' }
            ]
          });
        });
        html += '</ul>';
      }
    }

    scroll.innerHTML = html;
    syncProductButton();
  }

  /* ---- Quick add toggle on product cards --------------------------------- */
  function paintQuick(btn, on) {
    btn.classList.toggle('is-in-bag', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? btn.getAttribute('data-label-in') : btn.getAttribute('data-label-add');
    if (label) { btn.setAttribute('aria-label', label); btn.setAttribute('title', label); }
    var addIcon = btn.querySelector('[data-quick-icon="add"]');
    var inIcon = btn.querySelector('[data-quick-icon="in"]');
    if (addIcon) addIcon.hidden = on;
    if (inIcon) inIcon.hidden = !on;
  }

  function syncQuickButtons() {
    document.querySelectorAll('[data-quick]').forEach(function (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      paintQuick(btn, inBag.indexOf(String(btn.getAttribute('data-variant-id'))) !== -1);
    });
  }

  function toggleQuick(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = String(btn.getAttribute('data-variant-id'));
    var wasIn = inBag.indexOf(id) !== -1;

    // Flip immediately so it feels instant; the cart response confirms it.
    btn.setAttribute('aria-busy', 'true');
    btn.style.opacity = '.6';
    paintQuick(btn, !wasIn);

    var request;
    if (wasIn) {
      var line = ((lastCart && lastCart.items) || []).filter(function (i) { return String(i.variant_id) === id; })[0];
      request = line
        ? fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (r) { return r.json(); })
        : fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    } else {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      }).then(function (r) { return r.json(); });
    }

    request
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        btn.style.opacity = '';
        applyCart(cart);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.style.opacity = '';
        paintQuick(btn, wasIn);
      });
  }

  function applyCart(cart) {
    lastCart = cart;
    inBag = (cart.items || []).map(function (i) { return String(i.variant_id); });
    pruneSaved();
    updateCounters(cart.item_count);
    render();
    syncQuickButtons();
    validateStock(cart).then(render).catch(function () {});
    return cart;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applyCart)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(applyCart);
  }

  function addVariant(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { return refreshCart(); });
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { if (btn) btn.disabled = false; syncProductButton(); });
  }

  function initCart() {
    drawer = document.querySelector('[data-bag-drawer]');
    overlayEl = document.querySelector('[data-bag-overlay]');

    document.addEventListener('click', function (e) {
      var quick = e.target.closest('[data-quick]');
      if (quick) { e.preventDefault(); e.stopPropagation(); toggleQuick(quick); return; }

      if (!drawer) return;

      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-bag-close]') || e.target.closest('[data-bag-overlay]')) { e.preventDefault(); closeDrawer(); return; }

      var tab = e.target.closest('[data-bag-tab]');
      if (tab) { activeTab = tab.getAttribute('data-bag-tab'); render(); return; }

      if (e.target.closest('[data-prompt-dismiss]')) { dismissPrompt(); render(); return; }

      if (e.target.closest('[data-bag-continue]')) { closeDrawer(); return; }
      if (e.target.closest('[data-bag-checkout]')) {
        if (soldOut.length) return;
        window.location.href = '/checkout';
        return;
      }

      var save = e.target.closest('[data-save-later]');
      if (save) {
        var key = save.getAttribute('data-key');
        var id = save.getAttribute('data-id');
        var line = (lastCart && lastCart.items || []).filter(function (i) { return String(i.variant_id) === String(id); })[0];
        if (line) {
          addSaved({
            id: line.variant_id,
            brand: line.vendor || line.product_title,
            title: line.product_title,
            variant: (line.variant_title && line.variant_title.indexOf('Default') === -1) ? line.variant_title : '',
            price: formatMoney(line.final_line_price),
            image: line.image,
            url: line.url
          });
        }
        changeLine(key, 0);
        return;
      }

      var rm = e.target.closest('[data-remove]');
      if (rm) { changeLine(rm.getAttribute('data-key'), 0); return; }

      var move = e.target.closest('[data-move-to-bag]');
      if (move) {
        var mid = move.getAttribute('data-id');
        removeSaved(mid);
        activeTab = 'bag';
        addVariant(mid);
        return;
      }

      var drop = e.target.closest('[data-drop-saved]');
      if (drop) { removeSaved(drop.getAttribute('data-id')); render(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - lastCheck < 60000) return;
      refreshCart();
    });

    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form); });
    });

    refreshCart();
  }

  /* ---- Product page: variant selection + gallery ------------------------- */
  var pRoot, pVariants = [], pSelects, pIdField, pPriceEl, pAddBtn, pLabels;

  function currentVariant() {
    if (!pRoot) return null;
    if (!pSelects || !pSelects.length) return pVariants[0];
    var chosen = [];
    pSelects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
    return pVariants.filter(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    })[0];
  }

  function syncProductButton() {
    if (!pRoot || !pAddBtn) return;
    var v = currentVariant();
    if (!v) return;
    if (pIdField) pIdField.value = v.id;
    if (pPriceEl) pPriceEl.textContent = formatMoney(v.price);

    if (!v.available || soldOut.indexOf(String(v.id)) !== -1) {
      pAddBtn.disabled = true;
      pAddBtn.textContent = pLabels.sold;
    } else if (inBag.indexOf(String(v.id)) !== -1) {
      pAddBtn.disabled = true;
      pAddBtn.textContent = pLabels.bag;
    } else {
      pAddBtn.disabled = false;
      pAddBtn.textContent = pLabels.add;
    }
  }

  function initProduct() {
    pRoot = document.querySelector('[data-product-root]');
    if (!pRoot) return;
    try { pVariants = JSON.parse(pRoot.getAttribute('data-variants') || '[]'); } catch (e) { pVariants = []; }
    pSelects = pRoot.querySelectorAll('[data-option-index]');
    pIdField = pRoot.querySelector('[data-variant-id]');
    pPriceEl = pRoot.querySelector('[data-product-price]');
    pAddBtn = pRoot.querySelector('[type="submit"]');
    pLabels = {
      add: pRoot.getAttribute('data-label-add') || 'Add to bag',
      bag: pRoot.getAttribute('data-label-bag') || 'In your bag',
      sold: pRoot.getAttribute('data-label-sold') || 'Sold'
    };

    pSelects.forEach(function (s) { s.addEventListener('change', syncProductButton); });

    var main = pRoot.querySelector('[data-main-media]');
    pRoot.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.getAttribute('data-full');
        pRoot.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    syncProductButton();
  }

  /* ---- Boot -------------------------------------------------------------- */
  function boot() {
    initOverlay();
    initReveal();
    initProduct();
    initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();